import { defineComponent as _defineComponent } from 'vue'

import { Studio } from '@/modules/Studios/types'
import BKEditorConfig from '@/common/vue2Config'
import { VueEditor } from 'vue2-editor'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStudioInfo',
  props: {
    studio: null,
    studioImage: null,
    changeImage: null
  },
  setup(__props: any) {



return { __sfc: true,BKEditorConfig, VueEditor }
}

})